// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3UzmU","tab":"Tabs_tab__3_y08","tabActive":"Tabs_tabActive__1dZW8"};